import { ReactElement } from "react";
import { h } from "../../h";

export const Feedback = (): ReactElement => h(`div`, {}, `Feedback`);
